/**
 * Google tag (gtag.js), Consent Mode v2.
 *
 * The tag itself is loaded globally in public/index.html with consent
 * defaulted to "denied" (GDPR-safe, no cookies until consent). This module
 * syncs Google Consent Mode with the visitor's cookie-banner choices and
 * exposes the purchase-conversion helper.
 */
import { isCategoryEnabled } from "./cookieConsent";

const GTAG_ID = process.env.REACT_APP_GOOGLE_ADS_ID;

function syncConsent() {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const marketing = isCategoryEnabled("marketing");
    const analytics = isCategoryEnabled("analytics");
    window.gtag("consent", "update", {
        ad_storage: marketing ? "granted" : "denied",
        ad_user_data: marketing ? "granted" : "denied",
        ad_personalization: marketing ? "granted" : "denied",
        analytics_storage: analytics ? "granted" : "denied",
    });
}

export function initGtag() {
    if (typeof window === "undefined") return;
    syncConsent();
    window.addEventListener("elh-consent-change", syncConsent);
}

/** Fire the purchase conversion (post-payment success page, once per order). */
export function trackConversion({ value, currency = "EUR", transactionId }) {
    if (!GTAG_ID || typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    if (!isCategoryEnabled("marketing") && !isCategoryEnabled("analytics")) return;
    syncConsent();
    window.gtag("event", "conversion", {
        send_to: GTAG_ID,
        value: value || 0,
        currency,
        transaction_id: transactionId || "",
    });
}
